import BunkeyAPI from '../api/BunkeyAPI'
import {
  GET_STORAGE_HISTORY,
  GET_STORAGE_HISTORY_SUCCESS,
  GET_STORAGE_HISTORY_FAILURE,

  GET_ASSETS_LIST,
  GET_ASSETS_LIST_SUCCESS,
  GET_ASSETS_LIST_FAILURE,

  GET_FOLDER_SPACE,
  GET_FOLDER_SPACE_SUCCESS,
  GET_FOLDER_SPACE_FAILURE
} from "../constants/storage-types";
import _ from "lodash"; 

export const getStorageHistory = (workclient) => {
  return dispatch => {
    dispatch({ type: GET_STORAGE_HISTORY })
    BunkeyAPI({
      url: `/clients/${workclient}/getSpaceSizeMonth`,
      method: 'GET',
    }).then(resp => {
        const temp = resp.data.map(e => ({
            ...e,
            time: parseFloat(`${e.year},${e.mes}`),
            porcentaje: !_.isNil(e.porcentaje) ? parseFloat(e.porcentaje) : 0.0
        }));
        temp.sort((a, b) => {
          if (a.time < b.time) { return -1; }
          if (a.time > b.time) { return 1; }
          return 0;
        })
        dispatch({
            type: GET_STORAGE_HISTORY_SUCCESS,
            payload: {
                history: temp
            }
        })
    }).catch(err => {
      dispatch({
        type: GET_STORAGE_HISTORY_FAILURE,
        payload: err
      })
    })
  }
}

export const getAssetsList = (workclient, intl) => {
  return dispatch => {
    dispatch({ type: GET_ASSETS_LIST })
    BunkeyAPI({
      url: `/clients/${workclient}/objects/quantity`,
      method: 'GET',
    }).then(resp => {
      if (resp && resp.status === 200) {
        dispatch({
          type: GET_ASSETS_LIST_SUCCESS,
          payload: {
            assetList: [
              {
                title: intl.formatMessage({id: 'videos'}),
                qty: resp.data['videos'],
                background: '#F8BA0A',
                type: 'video'
              },
              {
                title: intl.formatMessage({id: 'files-audios'}),
                qty: resp.data['audios'],
                background: '#FFAEED',
                type: 'audio'
              },
              {
                title: intl.formatMessage({id: 'images'}),
                qty: resp.data['images'],
                background: '#BED9FA',
                type: 'image'
              },
              {
                title: intl.formatMessage({id: 'files-fonts'}),
                qty: resp.data['fonts'],
                background: '#19D491',
                type: 'font'
              },
              {
                title: intl.formatMessage({id: 'documents'}),
                qty: resp.data['documents'],
                background: '#DEAAD3',
                type: 'document'
              },
              {
                title: intl.formatMessage({id: 'files-others'}),
                qty: resp.data['others'],
                background: '#3AA52B',
                type: 'other'
              },
              {
                title: intl.formatMessage({id: 'bin'}),
                qty: resp.data['recycles'],
                background: '#E0091D',
                type: 'recycle'
              }
            ],
            totalAssets: resp.data['videos'] + resp.data['audios'] + resp.data['images'] + resp.data['fonts'] + resp.data['documents'] + resp.data['others'] + resp.data['fonts']
          }
        })
      }else{
        dispatch({
          type: GET_ASSETS_LIST_FAILURE,
          payload: {}
        })
      } 
    }).catch(err => {
      dispatch({
        type: GET_ASSETS_LIST_FAILURE,
        payload: err
      })
    })
  }
}

export const getFolderSpace = (workclient) => {
  return dispatch => {
    dispatch({ type: GET_FOLDER_SPACE })
    BunkeyAPI({
      url: `/clients/getSpaceFolder`,
      method: 'POST',
      data: {
        client: workclient
      }
    }).then(resp => {
      if (resp && resp.status === 200) {
        dispatch({
          type: GET_FOLDER_SPACE_SUCCESS,
          payload: {
            folderSpace: resp.data.size || 0,
            folderSpaceInBytes: resp.data.size_in_bytes || 0
          }
        })
      }else{
        dispatch({
          type: GET_FOLDER_SPACE_FAILURE,
          payload: {}
        })
      } 
    }).catch(err => {
      dispatch({
        type: GET_FOLDER_SPACE_FAILURE,
        payload: err
      })
    })
  }
}

